// extracted by mini-css-extract-plugin
export default {"shopDetails":"MyOrderDetail_shopDetails__ill5g","shopDetailCardContainer":"MyOrderDetail_shopDetailCardContainer__UzR5s","shopDetailCard":"MyOrderDetail_shopDetailCard__p5Dq6"};